<div class="maths" [formGroup]="maths">
   <div class="line">
      <mat-form-field class="date-field">
         <mat-label>{{placeholder}}</mat-label>
         <input matInput disabled [value]="getDate( -1 )" />
         <mat-hint *ngIf="operands.length">If ran today {{today | date}}</mat-hint>
      </mat-form-field>

      <mat-form-field>
         <span matPrefix class="common-mr1ex" *ngIf="operands.length">Start With</span>
         <mat-select formControlName="start">
            <mat-option *ngFor="let token of dateTokens" [value]="DateTokens[token]">{{token | spacers}}</mat-option>
         </mat-select>
      </mat-form-field>
   </div>

   <ng-container formArrayName="operands">
      <div class="line" *ngFor="let operand of operands.controls; index as i; last as isLast">
         <mat-form-field class="date-field">
            <mat-label *ngIf="isLast">It would use</mat-label>
            <input matInput disabled [value]="getDate( i )" />
         </mat-form-field>

         <ng-container [formGroup]="operand">
            <div>
               <mat-form-field class="common-w15ex">
                  <span matPrefix class="common-mr1ex">Then</span>
                  <mat-select formControlName="operation">
                     <mat-option value="+">Add</mat-option>
                     <mat-option value="-">Subtract</mat-option>
                     <mat-option value="~">Go To</mat-option>
                  </mat-select>
               </mat-form-field>

               <ng-container *ngIf="[ '+', '-' ].includes( operand.get( 'operation' ).value )">
                  <mat-form-field class="common-w7">
                     <input matInput formControlName="amount" type="number" min="1" class="common-taright common-pr1ex"/>
                     <mat-error libInputErrors [control]="operand.get( 'amount' )"></mat-error>
                  </mat-form-field>

                  <mat-form-field class="common-w15ex">
                     <span matPrefix class="common-mr1ex"></span>
                     <mat-select formControlName="period">
                        <mat-option *ngFor="let period of TimePeriods" [value]="period">
                           {{TimePeriodsMap.get( period )}}{{operand.get( 'amount' ).value > 1 ? 's' : ''}}
                        </mat-option>
                     </mat-select>

                     <button matSuffix mat-icon-button (click)="removeOperand( i )" class="common-ml2ex">
                        <mat-icon>clear</mat-icon>
                     </button>
                  </mat-form-field>
               </ng-container>

               <ng-container *ngIf="operand.get( 'operation' ).value === '~'">
                  <mat-form-field class="common-tacenter">
                     <mat-select formControlName="token">
                        <mat-option *ngFor="let token of relativeTokens" [value]="RelativeTokens[token]">{{token | spacers}}</mat-option>
                     </mat-select>

                     <button matSuffix mat-icon-button (click)="removeOperand( i )" class="common-ml2ex">
                        <mat-icon>clear</mat-icon>
                     </button>
                  </mat-form-field>
               </ng-container>
            </div>
         </ng-container>
      </div>

      <button mat-stroked-button (click)="addOperand()">
         <mat-icon>add</mat-icon> Add Then
      </button>
   </ng-container>
</div>
